import React, {useEffect, useState} from 'react';
import Wrapper from '../../components/Wrapper';
import Cropper from 'react-cropper';
import DashboardHeader from '../../components/DashboardHeader';
import './index.scss';
import Profile1 from '../../SVG/Profile1';
import Input from '../../components/Input';
import {useDispatch, useSelector} from 'react-redux';
import {Helmet} from 'react-helmet';
import {
  useSaveProfilePhotoMutation,
  useUpdateUserProfileMutation,
  useUpdateUserProfilePasswordMutation,
} from '../../store/builder/inspections.api';
import {setLoader} from '../../store/builder/reducer';
import {toast} from 'react-toastify';
import 'cropperjs/dist/cropper.css';
import axios from 'axios';
import {setUser} from '../../store/builder/loginSlice';
import {useNavigate} from 'react-router-dom';
import Checkbox from '../../components/Checkbox';
import CorporateRegions from '../../components/Corporate/CorporateRegions';
import CircleLockIcon from '../../SVG/CircleLockIcon';
import LanguageSelector from '../../components/LanguageSelector';
import {useTranslation} from '../../hooks/useTranslation';
import NotificationIcon from '../../SVG/NotificationIcon';
import Notifications from './components/Notifications';

export default function Profile() {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const [currentTab, setCurrentTab] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [chosenPhoto, setChosenPhoto] = useState(null);
  const [cropper, setCropper] = useState();
  const userInfo = useSelector(state => state?.rootReducer?.loginSlice?.user);
  const token = localStorage.getItem('ndx_user_token');
  const navigate = useNavigate();
  const changeTab = tabId => setCurrentTab(tabId);
  const [currentOrder, setCurrentOrder] = useState(null);
  const [eye, setEye] = useState(false);
  const [eyeConfirm, setEyeConfirm] = useState(false);
  const [userProfile, setUserProfile] = useState({
    first_name: userInfo?.first_name,
    last_name: userInfo?.last_name,
    ein: userInfo?.ein,
    initials: userInfo?.initials,
    notify_corrective_actions: userInfo?.notify_corrective_actions,
    notify_inspections: userInfo?.notify_inspections,
    notify_equipment: userInfo?.notify_equipment,
    notify_service_requests: userInfo?.notify_service_requests,
    notify_out_of_service: userInfo?.notify_out_of_service,
    notify_partial_inspection: userInfo?.notify_partial_inspection,
    notify_upcoming_oos: userInfo?.notify_upcoming_oos,
  });
  const [userPassword, setUserPassword] = useState({
    password: null,
    password_confirmation: null,
  });

  const [save, {data, isLoading, isError, error, isSuccess}] =
    useSaveProfilePhotoMutation();

  const [
    updateUser,
    {
      data: updateUserData,
      isLoading: updateUserIsLoading,
      isError: updateUserIsError,
      error: updateUserError,
      isSuccess: updateUserIsSuccess,
    },
  ] = useUpdateUserProfileMutation();

  const [
    updateUserPassword,
    {
      data: updateUserPasswordData,
      isLoading: updateUserPasswordIsLoading,
      isError: updateUserPasswordIsError,
      error: updateUserPasswordError,
      isSuccess: updateUserPasswordIsSuccess,
    },
  ] = useUpdateUserProfilePasswordMutation();

  useEffect(() => {
    if (userInfo?.agency?.is_settings_complete === false) {
      changeTab(7);
    }
  }, [userInfo]);

  useEffect(() => {
    if (updateUserIsLoading) {
      dispatch(setLoader(true));
    } else {
      dispatch(setLoader(false));
    }
    if (updateUserIsSuccess) {
      toast.success(updateUserData.message);
    }
    if (updateUserIsError) {
      toast.error(updateUserError?.data?.message);
    }
  }, [
    updateUserIsLoading,
    updateUserIsSuccess,
    updateUserIsError,
    updateUserError,
  ]);

  useEffect(() => {
    if (updateUserPasswordIsLoading) {
      dispatch(setLoader(true));
    } else {
      dispatch(setLoader(false));
    }
    if (updateUserPasswordIsSuccess) {
      toast.success(updateUserPasswordData.message);
    }
    if (updateUserPasswordIsError) {
      toast.error(updateUserPasswordError?.data?.message);
    }
  }, [
    updateUserPasswordIsLoading,
    updateUserPasswordIsSuccess,
    updateUserPasswordIsError,
    updateUserPasswordError,
  ]);

  useEffect(() => {
    if (isLoading) {
      dispatch(setLoader(true));
    } else {
      dispatch(setLoader(false));
    }
    if (isSuccess) {
      toast.success(data?.message);
    }
    if (isError) {
      toast.error(error?.data?.message);
    }
  }, [isLoading, isSuccess, isError, data, error]);

  useEffect(() => {
    if (typeof chosenPhoto === 'string') {
      setShowModal(true);
    } else {
      setShowModal(false);
    }
  }, [chosenPhoto]);

  useEffect(() => {
    setUserProfile(old => ({
      first_name: userInfo?.first_name,
      initials: userInfo?.initials,
      ein: userInfo?.ein,
      last_name: userInfo?.last_name,
      notify_corrective_actions: userInfo?.notify_corrective_actions,
      notify_inspections: userInfo?.notify_inspections,
      notify_equipment: userInfo?.notify_equipment,
      notify_service_requests: userInfo?.notify_service_requests,
      notify_out_of_service: userInfo?.notify_out_of_service,
      notify_partial_inspection: userInfo?.notify_partial_inspection,
      notify_upcoming_oos: userInfo?.notify_upcoming_oos,
    }));
  }, [userInfo?.notify_upcoming_oos]);

  const handleNotify = e => {
    setUserProfile(old => ({...old, [e.target.id]: e.target.checked}));
  };

  const handleUserChange = e => {
    setUserProfile(old => ({...old, [e.target.name]: e.target.value}));
  };
  const handlePasswordChange = e => {
    setUserPassword(old => ({...old, [e.target.name]: e.target.value}));
  };

  const cropperHandler = e => {
    e.preventDefault();
    let files;
    if (e.dataTransfer) {
      files = e.dataTransfer.files;
    } else if (e.target) {
      files = e.target.files;
    }
    const reader = new FileReader();
    reader.onload = () => {
      setChosenPhoto(reader.result);
    };
    reader.readAsDataURL(files[0]);
  };

  function base64ToBlob(base64Data) {
    const contentType = base64Data.substring(5, base64Data.indexOf(';'));
    const byteCharacters = atob(
      base64Data.substring(base64Data.indexOf(',') + 1),
    );
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
      const slice = byteCharacters.slice(offset, offset + 1024);
      const byteNumbers = new Array(slice.length);

      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, {type: contentType});
  }

  const getCropData = () => {
    if (typeof cropper !== 'undefined') {
      const form = new FormData();
      form.append(
        'profile_photo',
        base64ToBlob(cropper.getCroppedCanvas().toDataURL()),
      );
      save(form)
        .then(() => {
          setShowModal(false);
          refetch();
        })
        .catch(err => {
          toast.error(t('profile.messages.somethingWentWrong'));
        });
    }
  };

  return (
    <Wrapper>
      <Helmet>
        <title>{t('profile.pageTitle')}</title>
      </Helmet>
      <DashboardHeader title={t('profile.title')} />
      {showModal && (
        <div className='p-modal'>
          <div className='p-modal__content'>
            <div className='p-modal__header'>
              <p></p>
              <h5 className='p-modal__title'>
                {t('profile.modals.cropImage.title')}
              </h5>
              <div className='p-modal__close'>
                <img
                  src='/assets/icons/close.svg'
                  alt='close'
                  onClick={() => {
                    setShowModal(false);
                    setChosenPhoto(null);
                  }}
                />
              </div>
            </div>
            <div className='p-modal__cropper'>
              <Cropper
                style={{
                  height: 400,
                  width: '100%',
                }}
                zoomTo={0}
                initialAspectRatio={1}
                preview='.img-preview'
                src={chosenPhoto}
                aspectRatio={1}
                viewMode={0}
                minCropBoxHeight={300}
                minCropBoxWidth={300}
                background={false}
                responsive={true}
                autoCropArea={1}
                checkOrientation={false}
                onInitialized={instance => {
                  setCropper(instance);
                }}
                guides={true}
              />
            </div>
            <div className='p-modal__btns'>
              <label
                htmlFor='profile_photo'
                className='profile__imageBox-upload'
              >
                {t('profile.modals.cropImage.changePhoto')}
              </label>
              <div className='profile__imageBox-upload' onClick={getCropData}>
                {t('profile.modals.cropImage.savePhoto')}
              </div>
            </div>
          </div>
          <div
            className='p-modal__bg'
            // onClick={() => {
            //   setShowModal(false);
            //   setChosenPhoto(null);
            // }}
          ></div>
        </div>
      )}
      {showDeleteModal && (
        <div className='modal'>
          <div className='modal__content'>
            <div className='modal__content-head'>
              <p>{t('profile.modals.deleteCard.title')}</p>
              <img
                className='modal__content-exit'
                src='/assets/icons/close.svg'
                alt='close'
                onClick={() => setShowDeleteModal(false)}
              />
            </div>
            <div
              className='modal__content-body'
              style={{display: 'flex', justifyContent: 'center'}}
            >
              {t('profile.modals.deleteCard.message')}
            </div>
            <div className='modal__content-bottom'>
              <button
                className='close'
                onClick={() => setShowDeleteModal(false)}
              >
                {t('profile.modals.deleteCard.cancel')}
              </button>
              <button className='save danger'>
                {t('profile.modals.deleteCard.delete')}
              </button>
            </div>
          </div>
          <div className='modal__bg'></div>
        </div>
      )}
      <div className='profile'>
        <div className='profile__tabs'>
          <div
            className={`profile__tab ${currentTab === 0 ? 'active' : ''}`}
            onClick={() => {
              setCurrentOrder(null);
              changeTab(0);
            }}
          >
            <Profile1 active={currentTab === 0 && true} />
            <p className='profile__tab-name'>
              {t('profile.tabs.personalInformation')}
            </p>
          </div>
          <div
            className={`profile__tab ${currentTab === 1 ? 'active' : ''} ${userInfo?.is_sso_auth ? 'disabled' : ''}`}
            style={{pointerEvents: userInfo?.is_sso_auth ? 'none' : 'auto'}}
            onClick={() => {
              setCurrentOrder(null);
              changeTab(1);
            }}
          >
            <CircleLockIcon active={currentTab === 1 && true} />
            <p className='profile__tab-name'>
              {t('profile.tabs.updatePassword')}
            </p>
          </div>
          {!userInfo?.is_global && (
            <div
              className={`profile__tab ${currentTab === 3 ? 'active' : ''}`}
              onClick={() => {
                setCurrentOrder(null);
                changeTab(3);
              }}
            >
              <div
                className={`profile__tab-icon ${currentTab === 3 ? 'active' : ''}`}
              >
                <NotificationIcon
                  color={currentTab === 3 ? '#aeb3b7' : '#FFFFFF'}
                />
              </div>
              <p className='profile__tab-name'>
                {t('profile.notifications.title')}
              </p>
            </div>
          )}
        </div>
        <div className={`profile__box ${currentTab === 2 ? 'regions' : ''}`}>
          {currentTab === 0 ? (
            <div>
              <div className='profile__info column'>
                <div className='custom_title'>
                  <p>{t('profile.tabs.personalInformation')}</p>
                  <LanguageSelector />
                </div>
                <div className='profile__imageBox'>
                  <img
                    className='profile__avatar'
                    src={userInfo?.avatar}
                    alt='avatar'
                  />
                  {!userInfo?.is_sso_auth && (
                    <div>
                      <p className='profile__imageBox-desc'>
                        {t('profile.personalInformation.uploadDescription')}
                      </p>
                      <label
                        htmlFor='profile_photo'
                        className='profile__imageBox-label'
                      >
                        <input
                          type='file'
                          name='profile_photo'
                          id='profile_photo'
                          onChange={cropperHandler}
                          accept='image/jpeg, image/png, image/jpg'
                        />
                        {t('profile.personalInformation.uploadPhoto')}
                      </label>
                    </div>
                  )}
                </div>
              </div>
              <form className='profile__form'>
                <div className='profile__form-top'>
                  <div className='profile__form-separator'>
                    <div className='profile__form-input'>
                      <Input
                        label={t('profile.personalInformation.firstName')}
                        placeholder={t(
                          'profile.personalInformation.firstNamePlaceholder',
                        )}
                        name={'first_name'}
                        defaultValue={
                          userInfo?.first_name ? userInfo?.first_name : ''
                        }
                        onChange={handleUserChange}
                        containerWidth={500}
                        disabled={userInfo?.is_sso_auth}
                      />
                    </div>
                    <div className='profile__form-input'>
                      <Input
                        label={t('profile.personalInformation.lastName')}
                        placeholder={t(
                          'profile.personalInformation.lastNamePlaceholder',
                        )}
                        name={'last_name'}
                        defaultValue={
                          userInfo?.last_name ? userInfo?.last_name : ''
                        }
                        onChange={handleUserChange}
                        containerWidth={500}
                        disabled={userInfo?.is_sso_auth}
                      />
                    </div>
                    <div className='profile__form-input'>
                      <Input
                        label={t('profile.personalInformation.email')}
                        type={'email'}
                        placeholder={t(
                          'profile.personalInformation.emailPlaceholder',
                        )}
                        value={userInfo?.email}
                        containerWidth={500}
                        disabled={userInfo?.is_sso_auth}
                      />
                    </div>
                    <div className='profile__form-input'>
                      <Input
                        label={t('profile.personalInformation.ein')}
                        name={'ein'}
                        onChange={handleUserChange}
                        placeholder={t(
                          'profile.personalInformation.einPlaceholder',
                        )}
                        defaultValue={userInfo?.ein ? userInfo?.ein : ''}
                        containerWidth={500}
                        disabled={userInfo?.is_sso_auth}
                      />
                    </div>
                    <div className='profile__form-input'>
                      <Input
                        label={t('profile.personalInformation.initials')}
                        name={'initials'}
                        placeholder={t(
                          'profile.personalInformation.initialsPlaceholder',
                        )}
                        onChange={handleUserChange}
                        defaultValue={
                          userInfo?.initials ? userInfo?.initials : ''
                        }
                        containerWidth={500}
                        disabled={userInfo?.is_sso_auth}
                      />
                    </div>
                  </div>
                </div>
              </form>
              <button
                className='profile__methods-btn'
                onClick={() => updateUser(userProfile)}
              >
                {t('profile.personalInformation.save')}
              </button>
            </div>
          ) : currentTab === 1 ? (
            <div>
              <form className='profile__form' style={{margin: '0 0 30px'}}>
                <div className='profile__form-top'>
                  <div className='profile__form-password'>
                    <p>{t('profile.tabs.updatePassword')}</p>
                    <div className='profile__form-input'>
                      <Input
                        label={t('profile.updatePassword.password')}
                        type={eye ? 'text' : 'password'}
                        placeholder={t(
                          'profile.updatePassword.passwordPlaceholder',
                        )}
                        name={'password'}
                        onChange={handlePasswordChange}
                        containerWidth={500}
                      />
                      <img
                        className='eye'
                        src={
                          eye
                            ? '/assets/icons/eye-off.svg'
                            : '/assets/icons/eye.svg'
                        }
                        alt='eye'
                        onClick={() => {
                          setEye(!eye);
                        }}
                      />
                    </div>
                    <div className='profile__form-input'>
                      <Input
                        label={t('profile.updatePassword.confirmPassword')}
                        type={eyeConfirm ? 'text' : 'password'}
                        placeholder={t(
                          'profile.updatePassword.confirmPasswordPlaceholder',
                        )}
                        name={'password_confirmation'}
                        onChange={handlePasswordChange}
                        containerWidth={500}
                      />
                      <img
                        className='eye'
                        src={
                          eyeConfirm
                            ? '/assets/icons/eye-off.svg'
                            : '/assets/icons/eye.svg'
                        }
                        alt='eye'
                        onClick={() => {
                          setEyeConfirm(!eyeConfirm);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </form>
              <button
                className='profile__methods-btn'
                onClick={() => updateUserPassword(userPassword)}
              >
                {t('profile.updatePassword.save')}
              </button>
            </div>
          ) : currentTab === 2 ? (
            <CorporateRegions />
          ) : currentTab === 3 ? (
            <Notifications />
          ) : null}
        </div>
      </div>
    </Wrapper>
  );
}
